/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import { flexRender } from "@tanstack/react-table";
import useTableId from "context/tableId";
import TABLE_ROLES from "helpers/table/roles";
import getCellStyles from "helpers/table/getCellStyles";
import {
  baseCellCss,
  cellCss,
  cellNoDividerCss,
  getRowCss,
  headerGroupCss,
  tableBodyCss,
  getTableWrapperCss,
} from "./index.css";

export default function TableUI({
  getCenterTotalSize,
  getHeaderGroups,
  getRowModel,
  isDataUpdating,
  isWhite,
  isCustomScroll,
}) {
  const { tableId } = useTableId();

  return (
    <div id={tableId} css={getTableWrapperCss({ isCustomScroll })}>
      <div role={TABLE_ROLES.table} style={{ width: getCenterTotalSize() }}>
        {getHeaderGroups().map((headerGroup) => (
          <div
            key={headerGroup.id}
            role={TABLE_ROLES.row}
            css={headerGroupCss}
            style={{ backgroundColor: isWhite ? "white" : "#f1f3f4" }}
          >
            {headerGroup.headers.map(({ id, column, getSize, getContext }) => {
              const { sticky, header } = column.columnDef;
              const style = getCellStyles({ width: getSize(), sticky });

              return (
                <div
                  key={id}
                  role={TABLE_ROLES.columnHeader}
                  className="main-text-grey"
                  css={baseCellCss}
                  style={style}
                >
                  {flexRender(header, getContext())}
                </div>
              );
            })}
          </div>
        ))}

        <div role={TABLE_ROLES.rowGroup} css={tableBodyCss} className="flex-column">
          {getRowModel().rows.map((row) => (
            <div key={row.id} role={TABLE_ROLES.row} css={getRowCss({ isDataUpdating })}>
              {row.getVisibleCells().map(({ id, column, getContext }, index) => {
                const { sticky, cell, cellCustomCss } = column.columnDef;
                const style = getCellStyles({ width: column.getSize(), sticky });

                return (
                  <div
                    key={id}
                    role={TABLE_ROLES.cell}
                    className="text"
                    // first cell no divider
                    css={[index ? cellCss : cellNoDividerCss, cellCustomCss]}
                    style={style}
                  >
                    {flexRender(cell, getContext())}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

TableUI.propTypes = {
  getCenterTotalSize: PropTypes.func.isRequired,
  getHeaderGroups: PropTypes.func.isRequired,
  getRowModel: PropTypes.func.isRequired,
  isDataUpdating: PropTypes.bool,
  isWhite: PropTypes.bool,
  isCustomScroll: PropTypes.bool,
};
